module.exports = __webpack_public_path__ + "img/5.ae38e619.png";